import axios from 'axios'

const blogCannect = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL || 'https://api.cannect.life/v1'
})

export default blogCannect
